import ReactFlagsSelect from "react-flags-select";
import { FormGroup, Label } from "reactstrap";

const CountryListSelect = ({
  label,
  showSelectedLabel = true,
  showSecondarySelectedLabel = true,

  showOptionLabel = true,
  showSecondaryOptionLabel = true,

  placeholder = "",
  searchable = true,
  searchPlaceholder = "",
  alignOptionsToRight = false,
  fullWidth = true,
  disabled = false,
  name,
  onBlur,
  value,
  setFieldValue,
  errors,
  touched,
}) => {
  const onSelect = (code) => setFieldValue(name, code);
  return (
    <div className="custom_input_field">
      <FormGroup>
        {label && (
          <Label className="d-block w-100 mb-0 text-capitalize">{label}</Label>
        )}
        <ReactFlagsSelect
          name={name}
          selected={value}
          onBlur={onBlur}
          onSelect={onSelect}
          showSelectedLabel={showSelectedLabel}
          showSecondarySelectedLabel={showSecondarySelectedLabel}
          showOptionLabel={showOptionLabel}
          showSecondaryOptionLabel={showSecondaryOptionLabel}
          placeholder={placeholder}
          searchable={searchable}
          searchPlaceholder={searchPlaceholder}
          alignOptionsToRight={alignOptionsToRight}
          fullWidth={fullWidth}
          disabled={disabled}
          className="react-select-country"
        />
      </FormGroup>
      {touched?.[name] && errors?.[name] && (
        <span className="error text-danger">{errors?.[name]}</span>
      )}
    </div>
  );
};

export default CountryListSelect;
